class LockScreen {
  constructor(rootTagCls) {
    this.rootTag = document.documentElement;
    this.bodyTag = document.body;
    this.rootTagCls = rootTagCls;
    this.scrollCoords = 0;
    this.isLocked = false;
  }

  lock(customRootTagCls, coordsOnClick) {
    this.scrollCoords = window.scrollY;
    if (!this.isActive()) {
      setTimeout(() => {
        this.rootTag.classList.add(customRootTagCls || this.rootTagCls);
        const coords = coordsOnClick || this.scrollCoords;
        // if (this.rootTag.clientWidth < 768) {
        this.bodyTag.style.top = `-${coords}px`;
        // }
        this.isLocked = true;
      }, 405);
    }
  }

  unLock(customRootTagCls, coordsOnClick) {
    this.rootTag.classList.remove(customRootTagCls || this.rootTagCls);
    const coords = coordsOnClick || this.scrollCoords;
    // if (this.rootTag.clientWidth < 768) {
    this.bodyTag.style.removeProperty('top');
    this.rootTag.scrollTop = coords;
    // }
    this.scrollCoords = 0;
    this.isLocked = false;
  }

  isActive() {
    return this.rootTag.classList.contains(this.rootTagCls);
  }
}

export default LockScreen;
